<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6" type="">
                <div class="row py-4">
                    <div class="col-12 d-flex align-items-start justify-content-between">
                        <div class="flex-grow-1 text-start">
                            <h6 class="h2 d-inline-block mb-0">Orders for Strategy : <span class="text-primary">{{
                                formatPortfolioName(portfolioName) }}</span></h6>
                        </div>
                        <div>
                            <button class="btn btn-link" @click="redirect">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center py-4">
                    <div class="col-md-4">
                    </div>
                    <div class="col-md-4 mt-2 mt-md-0">
                        <el-select v-model="tempInstruments" multiple filterable placeholder="Select Instruments"
                            class="w-100">
                            <el-option v-for="option in instrumentOptions" :key="option" :label="option"
                                :value="option" />
                        </el-select>
                    </div>
                    <div class="col-md-4 mt-2 mt-md-0">
                        <el-select v-model="tempUserIds" multiple filterable placeholder="Select User IDs"
                            class="w-100">
                            <el-option v-for="option in userIdOptions" :key="option" :label="option" :value="option" />
                        </el-select>
                    </div>
                </div>
                <el-table class="table-responsive table-flush" header-row-class-name="thead-light" row-key="id"
                    :row-class-name="tableRowClassName" :data="orders" @selection-change="onSelectionChange">
                    <el-table-column type="selection" align="left" width="50px" :selectable="isRowSelectable" />
                    <el-table-column label="Type" min-width="120px" prop="type">
                        <template v-slot="scope">
                            <b>{{ scope.row.type }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column label="Trigger" min-width="120px" prop="trigger">
                        <template v-slot="scope">
                            <b>{{ scope.row.trigger }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column label="Instrument" min-width="220px" prop="instrument">
                        <template v-slot="scope">
                            <b>{{ scope.row.instrument }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column label="Trade Date" min-width="250px" prop="tradeDate">
                        <template v-slot="scope">
                            <b>{{ scope.row.tradeDate }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column label="UserId" min-width="250px" prop="userId">
                        <template v-slot="scope" :title="getUserName(scope.row.userId)">
                            <b>{{ getUserName(scope.row.userId) }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column label="Error" min-width="320px" prop="error">
                        <template v-slot="scope">
                            <b class="truncate-name" :title="scope.row.error">
                                {{ truncateError(scope.row.error) }}
                            </b>
                        </template>
                    </el-table-column>
                    <el-table-column label="Reorder" min-width="150px" prop="reOrder">
                        <template v-slot="scope">
                            <base-button class="mt-3" :class="tableActionClass(scope.row)" type="success" size="sm"
                                @click="placeOrder(scope.row)">
                                Reorder
                            </base-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="d-flex justify-content-end p-4">
                    <base-button class="mt-3" type="success" size="sm" @click="submitSelected">
                        Confirm
                    </base-button>
                </div>
            </base-header>
        </div>
    </div>
</template>
<script>
import { ElTable, ElTableColumn, ElTooltip, ElSelect, ElOption, ElNotification } from "element-plus";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
    components: {
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElTooltip.name]: ElTooltip,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElNotification.name]: ElNotification
    },
    data() {
        return {
            orders: [],
            selectedOrders: [],
            portfolioName: "",
            disableAction: false,
            tempUserIds: [],
            tempInstruments: [],
            userIdOptions: [],
            instrumentOptions: [],
            selectOptions: [],
        };
    },
    mounted() {
        const raw = sessionStorage.getItem("selectedStrategyOrders");
        if (raw) {
            const parsed = JSON.parse(raw);
            const { portfolioName, orders } = parsed;
            this.portfolioName = portfolioName;
            const flatOrders = orders.map(order => ({
                entryId: order.type === "Entry" ? order.id : null,
                exitId: order.type === "Exit" ? order.id : null,
                type: order.type,
                trigger: order.trigger,
                status: order.executedStatus,
                instrument: order.code,
                tradeDate: `${order.tradeDate} ${order.time}`,
                userId: order.userId || "N/A",
                error: order.brokerOrderRemarks || "-",
                portfolioName,
            }));
            this.orders = flatOrders;
            this.userIdOptions = [...new Set(flatOrders.map(order => order.userId))];
            this.instrumentOptions = [...new Set(flatOrders.map(order => order.instrument))];
        };
        this.getActiveUsers();
        ElNotification({
            title: 'Reminder!',
            message: 'Go back to the previous page to see updated details.',
            type: 'warning',
            duration: 10000,
        });
    },
    methods: {
        truncateError(text) {
            const maxLength = 15;
            if (!text) return '';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getUserName(userId) {
            let user = this.selectOptions.find(option => option.key === userId);
            return user ? user.value : " ";
        },
        getActiveUsers() {
            let data = {
                type: 'active-users'
            };
            if (sessionStorage.getItem(data.type + "-reference-data")) {
                this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
            } else {
                this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
                    .then(response => {
                        this.selectOptions = response.server.data;
                        sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.selectOptions));
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        onSelectionChange(selection) {
            this.selectedOrders = selection;
        },
        isRowSelectable(row) {
            return row.status !== 'PENDING';
        },
        formatPortfolioName(name) {
            return name
                .split('_')
                .map(word => {
                    return /^[a-zA-Z]+$/.test(word)
                        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                        : word;
                })
                .join(' ');
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.status && row.status == 'PENDING') {
                this.disableAction = true;
                return 'bg-table';
            }
            else {
                return 'enabled-action';
            }
        },
        tableActionClass(row) {
            if (row.status && row.status == 'PENDING') {
                return 'disabled-action';
            }
            else {
                return 'enabled-action'
            }
        },
        submitSelected() {
            if (this.selectedOrders.length === 0) {
                alert("Please select at least one order to confirm");
                return;
            }
            const payload = {
                orderIds: this.selectedOrders.map(order => order.entryId || order.exitId),
                type: this.selectedOrders[0]?.type?.toUpperCase() || "ENTRY",
            };
            this.$store.dispatch("orderStore/orderRetry", payload, { root: true })
                .then(response => {
                    console.log("Success:", response.data);
                    this.showSwal('success');
                })
                .catch(error => {
                    console.log(error);
                    this.showSwal('warning');
                });
        },
        showSwal(type) {
            if (type === "success") {
                swal.fire({
                    title: `Success`,
                    text: "Request to reorder the positions are placed.",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-success",
                    },
                    icon: "success",
                });
            } else if (type === "warning") {
                swal.fire({
                    title: `Warning`,
                    text: "Failed to reorder the selected positions.Try after some time.",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-warning",
                    },
                    icon: "warning",
                });
            }
        },
        placeOrder(selectedOrder) {
            const payload = {
                orderIds: [selectedOrder.entryId || selectedOrder.exitId],
                type: selectedOrder.type.toUpperCase(),
            };
            this.$store.dispatch("orderStore/orderRetry", payload, { root: true })
                .then(response => {
                    console.log("Success:", response.data);
                    this.showSwal('success');
                })
                .catch(error => {
                    console.log(error);
                    this.showSwal('warning');
                });
        },
        redirect() {
            this.$router.push({ name: 'OrderRetry' });
        }
    }
};
</script>
